import React from "react";
import { Column, ColumnId } from ".";
import base from "./base";
import SectorCellContent from "../components/SectorCellContent";

function sector({ width, language, onResize }: Column.Options) {
	return base(
		ColumnId.Sector,
		(item) => <SectorCellContent item={item} language={language} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default sector;
